import { Component, EventEmitter, Inject, Input, OnDestroy, OnInit, Output, Renderer2 } from "@angular/core";
import { IconService } from "../../services/icon.service";
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MAT_NATIVE_DATE_FORMATS, MatDateFormats } from "@angular/material/core";
import { DataService } from "../../services/data.service";
import { DOCUMENT } from "@angular/common";

const GRI_DATE_FORMATS: MatDateFormats = {
  ...MAT_NATIVE_DATE_FORMATS,
  display: {
    ...MAT_NATIVE_DATE_FORMATS.display,
    dateInput: {
      year: '2-digit',
      month: 'numeric',
      day: 'numeric',
    } as Intl.DateTimeFormatOptions
  }
};

@Component({
  selector: 'app-custom-datepicker',
  templateUrl: './custom-datepicker.component.html',
  styleUrls: ['./custom-datepicker.component.scss', './custom-datepicker.component.en.scss'],
  providers: [
    { provide: MAT_DATE_FORMATS, useValue: GRI_DATE_FORMATS },
  ]
})
export class CustomDatepickerComponent implements OnInit, OnDestroy {
  @Input() selectedDate: Date | null = null;
  @Input() culture: string = this.dataService.getCultureCode();
  @Input() icon: string = '/Content/Images/icons/calendar.svg';
  @Input() placeholder: string = '';
  @Input() closeWhenSelected: boolean = true;
  @Input() disabled: boolean = false;

  @Output() dateChange = new EventEmitter<Date>();

  private _listeners: Function[] = [];

  constructor(
    private _adapter: DateAdapter<any>,
    @Inject(MAT_DATE_LOCALE) private _locale: string,
    private iconService: IconService,
    private readonly dataService: DataService,
    @Inject(DOCUMENT) private document: Document,
    private renderer: Renderer2
  ) {
    this.iconService.addIconToRegistry({
        key: this.icon,
        path: this.icon,
      });
  }

  ngOnInit(): void {
    this._locale = this.culture;
    this._adapter.setLocale(this._locale);
  }

  ngOnDestroy() {
    this.clearListeners();
  }

  protected changeDate(event: any, datepicker: any) {
    if (this.closeWhenSelected) {
      datepicker.close();
    }
    this.dateChange.emit(event);
  }

  protected clearFocus() {
    setTimeout(() => {
      var temp = this.document.createElement("input");
      this.document.body.appendChild(temp);
      temp.focus();
      this.document.body.removeChild(temp);
    }, 10)
  }

  pickerOpen() {
    this.addAdditionalBlockToCalendar();

    setTimeout(() => {
      let buttons = this.document.querySelectorAll('.mat-calendar-previous-button,.mat-calendar-next-button');
      if(buttons) {
        Array.from(buttons).forEach(button => {
          this._listeners.push(this.renderer.listen(button, "click", (event) => {
            this.addAdditionalBlockToCalendar();
          }));
        })
      }
    }, 0);
  }

  pickerClose() {
    this.clearListeners();
  }

  protected addAdditionalBlockToCalendar() {
    //if(LocalizationService.showHebrewElements()) return;

    setTimeout(() => { 
      let table = this.document.querySelector('mat-month-view');
      if(!table) return;
      let tableBody = table.querySelector('.mat-calendar-body');
      if(!tableBody) return;
      let firstTr = tableBody.querySelector('tr');
      let cols = firstTr!.querySelectorAll('td[role="gridcell"]');
      if(!cols || cols.length == 0) return;
  
      let diffCount = 7 - cols.length;
      if(diffCount <= 1) return;
  
      let emptyCol = this.document.createElement('td');
      emptyCol.setAttribute('colspan', diffCount.toString());
      firstTr!.insertBefore(emptyCol, firstTr!.firstChild);
    }, 0);
  }

  private clearListeners() {
    this._listeners.forEach((listener) => listener());
    this._listeners = [];
  }
}